import axiosInstance from "@/utils/axiosInstance";

const baseUrl = `api/widgets`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  getWidgetTypeList({ commit }) {
    return axiosInstance.get(`${baseUrl}/type-list`, {})
      .then((data) => data.data);
  }, getById({ commit }, payload: { dashboardId: number, widgetId: number, params: { companyId: number } }) {
    return axiosInstance.get(`${baseUrl}/${payload.widgetId}`, { params: payload.params })
      .then((data) => data.data);
  }, editWidget({ commit }, payload: { widgetId: number, widgetData: any }) {
    return axiosInstance.put(`${baseUrl}/${payload.widgetId}`, payload.widgetData)
      .then((data) => data.data);
  }, deleteWidget({ commit }, payload: { widgetId: number }) {
    return axiosInstance.delete(`${baseUrl}/${payload.widgetId}`)
      .then((data) => data.data);
  },
};

export default {
  namespaced: true, state, getters, actions, mutations,
};
